import React from 'react';
import './UserProfile.css';

interface UserProfileProps {
  metadata?: Record<string, unknown>;
  avatarUrl?: string;
  onCreateNewAvatar?: () => void;
}

export const UserProfile: React.FC<UserProfileProps> = ({ metadata, avatarUrl, onCreateNewAvatar }) => {
  // Safe extraction of user data
  const age = (metadata?.age as string) || '-';
  const height = (metadata?.height as string) || '-';
  const weight = (metadata?.weight as string) || '-';
  const bodyType = (metadata?.bodyType as string) || '-';
  const gender = (metadata?.gender as string) || '-';

  return (
    <div className="user-profile">
      <div className="user-profile__header">
        <div className="user-profile__avatar-container">
          {avatarUrl ? (
            <img 
              src={avatarUrl} 
              alt="User Avatar" 
              className="user-profile__avatar" 
            />
          ) : (
            <div className="user-profile__avatar-placeholder">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
          )}
        </div>
        <h2 className="user-profile__title">Profilim</h2>
      </div>

      <div className="user-profile__stats">
        <div className="user-profile__stat-card">
          <div className="user-profile__stat-icon">🎂</div>
          <div className="user-profile__stat-content">
            <span className="user-profile__stat-label">Yaş</span>
            <span className="user-profile__stat-value">{age}</span>
          </div>
        </div>

        <div className="user-profile__stat-card">
          <div className="user-profile__stat-icon">📏</div>
          <div className="user-profile__stat-content">
            <span className="user-profile__stat-label">Boy</span>
            <span className="user-profile__stat-value">{height} cm</span>
          </div>
        </div>

        <div className="user-profile__stat-card">
          <div className="user-profile__stat-icon">⚖️</div>
          <div className="user-profile__stat-content">
            <span className="user-profile__stat-label">Kilo</span>
            <span className="user-profile__stat-value">{weight} kg</span>
          </div>
        </div>

        <div className="user-profile__stat-card">
          <div className="user-profile__stat-icon">👤</div>
          <div className="user-profile__stat-content">
            <span className="user-profile__stat-label">Vücut Tipi</span>
            <span className="user-profile__stat-value">{bodyType}</span>
          </div>
        </div>
        
        <div className="user-profile__stat-card">
          <div className="user-profile__stat-icon">⚧</div>
          <div className="user-profile__stat-content">
            <span className="user-profile__stat-label">Cinsiyet</span>
            <span className="user-profile__stat-value">{gender === 'female' ? 'Kadın' : gender === 'male' ? 'Erkek' : '-'}</span>
          </div>
        </div>
      </div>

      {onCreateNewAvatar && (
        <button 
          className="user-profile__new-avatar-btn"
          onClick={onCreateNewAvatar}
        >
          <span className="user-profile__new-avatar-icon">✨</span>
          Yeni Avatar Oluştur
        </button>
      )}
    </div>
  );
};

export default UserProfile;
